'use strict';

const Base = require('components/Base/Base.js');

require('./IndexConcerts.less');

module.exports = Base.extend({

    el: '.IndexConcerts',

    events: {
        'click span.link-inner': 'onInnerLinkClick',
        'click .IndexConcerts-list-item': 'onInnerLinkClick'
    },

    initialize: function () {
        Base.prototype.initialize.call(this, {});

        this.$('.IndexConcerts-image').onCustom('screen-position', function (e, data) {
            if (data.screenPosition > 0.4) {
                data.screenPosition = 0.4;
                data.$el[0].setAttribute('data-opened', 1);
            } else {
                data.$el[0].setAttribute('data-opened', 0);
            }
            var percentage = 1 - app.utils.easingFunctions(0, 1, data.screenPosition * 2.5, 'easeOutQuad');
            data.$el[0].style.transform = 'translate3d(' + -100 * percentage + '%, 0, 0)';
        }.bind(this));
    }
});
